// extracted by mini-css-extract-plugin
export default {"top":"CountDown_top__RkPEv","time":"CountDown_time__YGfTo","time2":"CountDown_time2__wC2iQ","settingBtn":"CountDown_settingBtn__jduAI","button":"CountDown_button__WyK2p"};